import {getSettings} from "../../api/settings"

export const state = {
  gotSettings: false,
  authSettings: {},
  baseUrl: null,
  authUrl: null,
}

export const mutations = {
  WATCH_MODE (state, value) { state.mode = value },
  WATCH_GOT_SETTINGS (state, value) { state.gotSettings = value },
  WATCH_BASE_URL (state, value) { state.baseUrl = value },
  WATCH_AUTH_URL (state, value) { state.authUrl = value },
  WATCH_AUTH_SETTINGS (state, value) { state.authSettings = value },
}

export const getters = {
  authSettings: state => state.authSettings,
  gotSettings: state => state.gotSettings,
  baseUrl: state => state.baseUrl,
  authUrl: state => state.authUrl,
  username: state => state.username
}

export const actions = {
  fetchAppSettings ({commit, getters}) {
    if (getters.gotSettings) return Promise.resolve({})
    return getSettings()
      .then(response => {
        commit('WATCH_GOT_SETTINGS', true)
        commit('WATCH_BASE_URL', response.data.base_url)
        commit('WATCH_AUTH_URL', response.data.auth_url)
        commit('WATCH_AUTH_SETTINGS', response.data.auth)
        commit('WATCH_MODE', response.data.mode || 'prod')
        return Promise.resolve(response)
      })
      .catch(error => {
        commit('WATCH_GOT_SETTINGS', false)
        return Promise.reject(error)
      })
  },
}
